import styled, {css} from 'astroturf/react';

const Wrapper = styled('div')`
  width: 100%;
  height: 95%;
`;

const Buttons = styled('div')`
  text-align: center;

  button + button {
    margin-left: 15px;
  }
`;

export default { Wrapper, Buttons };
